import { render, staticRenderFns } from "./labelingDetail.vue?vue&type=template&id=52714933&scoped=true&"
import script from "./labelingDetail.vue?vue&type=script&lang=js&"
export * from "./labelingDetail.vue?vue&type=script&lang=js&"
import style0 from "./labelingDetail.vue?vue&type=style&index=0&id=52714933&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52714933",
  null
  
)

export default component.exports